import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('phone_enabled', '0 0 32 32', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M23.173 14.387l-2.933-2.934a1.338 1.338 0 01-.333-1.36c.493-1.493.76-3.093.76-4.76C20.667 4.6 21.267 4 22 4h4.667C27.4 4 28 4.6 28 5.333 28 17.853 17.853 28 5.333 28 4.6 28 4 27.4 4 26.667v-4.654c0-.733.6-1.333 1.333-1.333a15.21 15.21 0 004.76-.76c.467-.16 1-.04 1.36.32l2.934 2.933a20.198 20.198 0 008.786-8.786z" })));
